function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "success-props",
    width: "402px",
    height: "340.9px",
    style: {
      enableBackground: "new 0 0 402 340.9"
    },
    viewBox: "0 0 402 340.9",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m211.8 208c3.2 46 49.1 71.8-12.2 63.2 0 0-39.7 7.9-27.9-11.4 11.9-19.3 16.5-51.8 16.5-51.8",
    style: {
      fill: "#F4AB37"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m247 294.2h-92c-10.2 0-18.6-8.4-18.6-18.6s8.4-18.6 18.6-18.6h91.9c10.2 0 18.6 8.4 18.6 18.6 0.1 10.2-8.3 18.6-18.5 18.6z",
    style: {
      fill: "#FFD13D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.3,280.8C48.2,246.3,12.2,110.6,84.2,40.4",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m97.8 260.6c-21-18.9-7.9-44-3.5-63.1 0 0 32.2 39.1 3.5 63.1z",
    style: {
      fill: "#F18126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65 221.2c-9.4-25.9 7.4-38.4 20.5-54 0 0 15.4 49.1-20.5 54z",
    style: {
      fill: "#F18126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m74.7 119.9c-23.5 12.2-33.1 22.8-27.9 48.6 14.9-3.3 36.1-23.8 29.6-46.5l-1.7-2.1z",
    style: {
      fill: "#F18126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.6 159.2c-8.8-19.6-26.3-23.5-44.6-22.7 0 0 8 37.4 45.6 30.8",
    style: {
      fill: "#F18126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61 213.8c-10.1-13.5-29.8-16.9-45.9-11.2 0 0 10.7 35 51.3 21",
    style: {
      fill: "#F18126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.5 251.8c-8.5-5.7-39-4.9-43.9 8.9 10.7 11.4 42.6 15.3 54.1 0.8",
    style: {
      fill: "#F18126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47 114.7c-24.8-8.1-26.7-33.1-23.9-52.3 6.4 1.7 35.5 22.2 23.9 52.3z",
    style: {
      fill: "#F18126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.1 104.5c6.8-15.1 33.9-22.4 48.4-17.3-6.3 20-28.2 33.7-50.3 26l1.9-8.7z",
    style: {
      fill: "#F18126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.3 67.2c-20.9-17.1-11.8-42.3-7.9-60.7 3.1 1 34.1 34.6 7.9 60.7z",
    style: {
      fill: "#F18126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70 58s17.1-13.4 37.6-7.5c20.5 5.8-13.3 36.8-42.8 15.7l5.2-8.2z",
    style: {
      fill: "#F18126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m111.8 12.2c0.9-6.3 0.8-11.1 0.8-11.1-21.7 9-36.2 17.4-33.8 45.4-0.4 0.7 18.2-4.4 26-14.6l7-19.7z",
    style: {
      fill: "#F18126"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.1,
    y: 274.4,
    width: 231,
    height: 65.6,
    style: {
      fill: "#8E5E36"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.3,
    y: 282.8,
    width: 190.7,
    height: 48.5,
    style: {
      fill: "#FFD13D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m139.2 170.2c-113.9-53.7-87.6-150.2-24.8-105.8l-7.4 8 3.7-4-3.7 4c-54.8-34.5-50.6 49.3 37 88.1l-4.8 9.7z",
    style: {
      fill: "#FFD13D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m275.7 280.8c78-34.5 114.2-170.3 42.1-240.4",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m304.2 260.6c21-18.9 7.9-44 3.5-63.1 0 0-32.2 39.1-3.5 63.1z",
    style: {
      fill: "#F18126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m337 221.2c9.4-25.9-7.4-38.4-20.5-54 0 0-15.4 49.1 20.5 54z",
    style: {
      fill: "#F18126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m325.7 122.1c-6.4 22.7 14.8 43.3 29.6 46.5 5.2-25.8-4.5-36.6-27.9-48.6l-1.7 2.1z",
    style: {
      fill: "#F18126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m356.4 159.2c8.7-19.6 26.4-23.5 44.6-22.8 0 0-8 37.4-45.6 30.8",
    style: {
      fill: "#F18126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m341 213.8c10.1-13.5 29.8-16.9 45.9-11.2 0 0-10.7 35-51.3 21",
    style: {
      fill: "#F18126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m313.5 251.8c8.5-5.7 39-4.9 43.9 8.9-10.7 11.4-42.6 15.3-54.1 0.8",
    style: {
      fill: "#F18126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m355 114.7c24.8-8.1 26.7-33.1 23.9-52.3-6.4 1.7-35.5 22.2-23.9 52.3z",
    style: {
      fill: "#F18126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m352.9 104.5c-6.8-15.1-33.9-22.4-48.4-17.3 6.3 20 28.2 33.7 50.3 26l-1.9-8.7z",
    style: {
      fill: "#F18126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m338.7 67.2c20.8-17.1 11.9-42.3 7.9-60.7-3.1 1-34.1 34.6-7.9 60.7z",
    style: {
      fill: "#F18126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m332 58s-17.1-13.4-37.6-7.5c-20.5 5.8 13.3 36.8 42.8 15.7l-5.2-8.2z",
    style: {
      fill: "#F18126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m297.3 31.8c7.9 10.3 26.3 15.2 26 14.6 2.5-28.3-12.5-36.5-33.9-45.4-1.5 6.2 5.2 23.8 7.9 30.8z",
    style: {
      fill: "#F18126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m262.8 170.2c113.9-53.7 87.5-150 24.7-105.8l7.4 8-3.7-4 3.6 4c54.8-34.5 50.6 49.3-37 88.1l5 9.7z",
    style: {
      fill: "#FFD13D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m298 31.7c3.7 233.8-198.1 233.1-194.2 0",
    style: {
      fill: "#FFD13D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m297 31.8h-192c-5.4 0-9.8-4.4-9.8-9.8s4.4-9.8 9.8-9.8h191.9c5.4 0 9.8 4.4 9.8 9.8 0.1 5.4-4.3 9.8-9.7 9.8z",
    style: {
      fill: "#FFD13D"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "shadow"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m96.1 26.1h190.3s12.2-11.1 9-13.1c-3.1-2 8.2-1.4 10.3 5.8 1.8 11.5-2.4 10.4-7.6 13.5h-191.6s-5.7-0.9-5.7-0.9",
    style: {
      enableBackground: "new",
      opacity: 0.22
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m281.6 31.7c4 30-25 208.2-116.4 165.8 47.1 36.9 101.9-16.6 117-63.9 13.3-38.4 16.5-72.1 15.5-101.9",
    style: {
      enableBackground: "new",
      opacity: 0.22
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m188.4 210.8s14.1 1.5 15.8 3.8c1.8 2.3 7.5 31.6 12.9 41.5l10.2 0.8c-1.6-3.8-16.5-40-15.5-47.5-6.9-0.2-16.7-0.8-23.6-0.7",
    style: {
      enableBackground: "new",
      opacity: 0.22
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "279.8 283.1 279.8 324 105 324 105 331.4 295.4 331.4 295.4 283.1",
    style: {
      enableBackground: "new",
      opacity: 0.22
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "stroke"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m297 31.8h-192c-5.4 0-9.8-4.4-9.8-9.8v0c0-5.4 4.4-9.8 9.8-9.8h191.9c5.4 0 9.8 4.4 9.8 9.8v0c0.1 5.4-4.3 9.8-9.7 9.8z",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m298 31.7c3.7 233.8-198.1 233.1-194.2 0",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m138.5 169.7c-38.6-19.2-78.7-52.6-78.2-88.8-0.4-26.6 27-33.5 44.1-23.4",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m127.8 151.4c-69.4-37-73.1-109.7-22.2-80.2",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m297.7 57.6c17.2-10.3 44.7-3 44.1 23.7 0.2 36-39.7 69.4-78.2 88.5v0",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m296.5 71.1c50.8-29.4 47.1 43.2-22.3 80.3",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m173.5 256.9c10.7-19.5 14.9-48.9 14.9-48.9",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m211.8 208s4.6 29.4 16.1 48.9",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m136.5 274.4c0.6-9.7 8.8-17.4 18.5-17.4h91.9c9.8 0 18 7.7 18.6 17.5",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m111.8 12.2c0.9-6.3 0.8-11.1 0.8-11.1-21.7 9-36.2 17.4-33.8 45.4-0.4 0.7 18.2-4.4 26-14.6",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.5 58.8c0.2-0.3 0.3-0.5 0.5-0.8v0 0c4.6-6.8 9-12.2 14.1-17.6",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.3 67.2c-20.9-17.1-11.8-42.3-7.9-60.7 0 0 29.7 24.7 13.9 52.5",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70 58v0 0c0.9-0.7 15.8-11.7 34-8.3",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.5 71c11.1 4.4 22 2.5 29.7-1.4",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.5 72.2v0c-4.9 9.1-9.3 20.4-12.3 32.2v0c-20.1 67.9 22.1 145.3 66.4 169.7",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47 114.7c-24.8-8.1-26.7-33.1-23.9-52.3 0 0 26.9 11.3 26.7 39.7",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.1 104.5s4-7.2 12.2-12.5",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.6 87.6c14.3-3.5 27-0.4 25.9-0.3 0 0-5.6 15-16.8 22.4",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.3 113.2s8.7 3.8 23.3 0.7",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.6 159.2c-8.8-19.6-26.3-23.5-44.6-22.7 0 0 8 37.4 45.6 30.8",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.9 162.9c-4-21.9 9.8-33.4 28.7-42.9",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.7 168.6c14.8-3.3 36.1-23.8 29.6-46.5",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61 213.8c-10.1-13.5-29.8-16.9-45.9-11.2 0 0 10.7 35 51.3 21",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65 221.2c-9.4-25.9 7.4-38.4 20.5-54 0 0 15.4 49.1-20.5 54z",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.5 251.8c-8.5-5.7-39-4.9-43.9 8.9 10.7 11.4 42.6 15.3 54.1 0.8",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m97.8 260.6c-21-18.9-7.9-44-3.5-63.1 0 0 32.2 39.1 3.5 63.1z",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m297.3 31.8c7.9 10.3 26.3 15.2 26 14.6 2.5-28.3-12.5-36.5-33.9-45.4 0 0-0.2 4.8 0.8 11.1",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m317.8 40.3c5 5.4 9.6 10.8 14.1 17.6v0 0c0.2 0.3 0.3 0.5 0.5 0.8",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m298 49.7c18.3-3.4 33 7.6 34 8.3v0 0",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m298.8 69.4c7.7 4.1 18.6 5.8 29.7 1.4",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m332.7 58.9c-15.8-27.7 13.9-52.5 13.9-52.5 4 18.7 12.9 43.7-7.9 60.8",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m340.5 72.2v0c4.9 9.1 9.3 20.4 12.3 32.2v0c20.1 67.9-22.2 145.3-66.4 169.7",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m340.6 92c8.2 5.3 12.3 12.5 12.3 12.5",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m321.2 109.7c-11.2-7.5-16.8-22.5-16.8-22.5-1-0.1 11.5-3.2 25.9 0.3",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m331.5 113.8c14.6 3.2 23.3-0.7 23.3-0.7",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m355 114.7c24.8-8.1 26.7-33.1 23.9-52.3 0 0-26.9 11.3-26.7 39.7",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m327.3 119.9c19 9.7 32.7 20.9 28.7 42.9",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m325.7 122.1c-6.4 22.7 14.8 43.3 29.6 46.5",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m356.4 159.2c8.7-19.6 26.4-23.5 44.6-22.8 0 0-8 37.4-45.6 30.8",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m337 221.2c9.4-25.9-7.4-38.4-20.5-54 0 0-15.4 49.1 20.5 54z",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m341 213.8c10.1-13.5 29.8-16.9 45.9-11.2 0 0-10.7 35-51.3 21",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m304.2 260.6c21-18.9 7.9-44 3.5-63.1 0 0-32.2 39.1-3.5 63.1z",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m313.5 251.8c8.5-5.7 39-4.9 43.9 8.9-10.7 11.4-42.6 15.3-54.1 0.8",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.1,
    y: 274.4,
    width: 231,
    height: 65.6,
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.3,
    y: 282.8,
    width: 190.7,
    height: 48.5,
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "#000"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.63b4177488223f624b31e8de801f9943.svg";
export { ForwardRef as ReactComponent };